import React, { useState, useEffect, useRef, useMemo } from "react";
import { Form } from "react-bootstrap";
import * as CustomToast from "../components/CustomToastMessage";

function BlogImageUpload({
  onFileSelect,
  initialImage,
  imageMaxWidth = null,
  imageMaxHeight = null,
  name = "",
}) {
  const [imageSrc, setImageSrc] = useState(initialImage || null);
  const [isLocalImage, setIsLocalImage] = useState(false);
  const inputRef = useRef(null);
  const objectUrlRef = useRef(null);
  const controlId = useMemo(
    () => `formFile-${name || Math.random().toString(36).slice(2)}`,
    [name]
  );

  // Cleanup any object URL we created
  useEffect(() => {
    return () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
      }
    };
  }, []);

  // Reflect initialImage from parent without clobbering local selection
  useEffect(() => {
    if (initialImage == null) {
      // reset
      setImageSrc(null);
      setIsLocalImage(false);
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
      return;
    }

    // If parent provides a server path or absolute URL
    if (typeof initialImage === "string") {
      setImageSrc(initialImage);
      setIsLocalImage(false);
      return;
    }

    // If parent provides a File/Blob (e.g., after selecting)
    if (initialImage instanceof File || initialImage instanceof Blob) {
      // Create/recreate object URL for preview
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
      }
      const url = URL.createObjectURL(initialImage);
      objectUrlRef.current = url;
      setImageSrc(url);
      setIsLocalImage(true);
    }
  }, [initialImage]);

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      CustomToast.error("Please select an image file");
      e.target.value = "";
      return;
    }

    const tmpUrl = URL.createObjectURL(file);
    const img = new Image();
    img.src = tmpUrl;

    img.onload = () => {
      const { width, height } = img;

      // if (
      //   imageMaxWidth &&
      //   imageMaxHeight &&
      //   (width > imageMaxWidth || height > imageMaxHeight)
      // ) {
      //   CustomToast.error(
      //     `Image dimensions must not exceed ${imageMaxWidth}x${imageMaxHeight} pixels (yours: ${width}x${height})`
      //   );
      //   URL.revokeObjectURL(tmpUrl);
      //   e.target.value = "";
      //   return;
      // }

      // Valid image: preview and notify parent
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
      }
      objectUrlRef.current = tmpUrl;
      setImageSrc(tmpUrl);
      setIsLocalImage(true);
      onFileSelect(file);
    };

    img.onerror = () => {
      CustomToast.error("Invalid image file");
      URL.revokeObjectURL(tmpUrl);
      e.target.value = "";
    };
  };

  const handleDelete = () => {
    setImageSrc(null);
    setIsLocalImage(false);
    if (objectUrlRef.current) {
      URL.revokeObjectURL(objectUrlRef.current);
      objectUrlRef.current = null;
    }
    if (inputRef.current) inputRef.current.value = "";
    onFileSelect(null);
  };

  const handleEdit = () => {
    if (inputRef.current) inputRef.current.click();
  };

  const isAbsoluteUrl =
    typeof imageSrc === "string" && /^(https?:)?\/\//i.test(imageSrc);
  const resolvedSrc = isLocalImage
    ? imageSrc
    : imageSrc
    ? isAbsoluteUrl
      ? imageSrc
      : `${process.env.REACT_APP_BACKEND_URL}/${imageSrc}`
    : null;

  return (
    <>
      <Form.Group controlId={controlId}>
        <Form.Control
          id={controlId}
          ref={inputRef}
          className="d-none"
          type="file"
          accept="image/png, image/jpeg, image/jpg"
          onChange={handleFileChange}
          name={name}
        />
        {imageSrc ? (
          <div className="text-center image-preview d-flex justify-content-center align-items-center position-relative">
            <div className="rounded-3 overflow-hidden h-100 w-100">
              <img
                src={resolvedSrc || ""}
                alt="Uploaded"
                className="w-100 h-100 object-fit-cover"
              />
            </div>
            <div className="d-flex align-items-center gap-3 position-absolute top-0 end-0 m-3">
              <img
                src="/images/png/img-delete.png"
                className="pointer"
                width={40}
                height={40}
                onClick={handleDelete}
                alt="Delete Icon"
              />
              <img
                src="/images/png/img-edit.png"
                className="pointer"
                width={40}
                height={40}
                onClick={handleEdit}
                alt="Edit Icon"
              />
            </div>
          </div>
        ) : (
          <Form.Label
            className="images-upload d-flex justify-content-center align-items-center"
            htmlFor={controlId}
          >
            <div>
              <img
                className="d-flex justify-content-center m-auto"
                src="/images/png/upload.png"
                width={40}
                height={40}
                alt="Upload Icon"
              />
              <span>Select your file</span>
            </div>
          </Form.Label>
        )}
      </Form.Group>
    </>
  );
}

export default BlogImageUpload;

// import React, { useState, useEffect } from "react";
// import { Form } from "react-bootstrap";
// import * as CustomToast from "../components/CustomToastMessage";

// function BlogImageUpload({
//   onFileSelect,
//   initialImage,
//   imageMaxWidth = null,
//   imageMaxHeight = null,
//   name = "",
// }) {
//   const [imageSrc, setImageSrc] = useState(initialImage || null);
//   const [isLocalImage, setIsLocalImage] = useState(false);

//   useEffect(() => {
//     if (initialImage) {
//       setImageSrc(initialImage);
//       setIsLocalImage(false);
//     }
//   }, [initialImage]);

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (!file.type.startsWith("image/")) {
//         CustomToast.error("Please select an image file");
//         return;
//       }

//       const img = new Image();
//       const objectUrl = URL.createObjectURL(file);
//       img.src = objectUrl;

//       img.onload = () => {
//         const { width, height } = img;

//         // Dimension validation
//         if (
//           imageMaxWidth &&
//           imageMaxHeight &&
//           (width > imageMaxWidth || height > imageMaxHeight)
//         ) {
//           CustomToast.error(
//             `Image dimensions must not exceed ${imageMaxWidth}x${imageMaxHeight} pixels (yours: ${width}x${height})`
//           );
//           URL.revokeObjectURL(objectUrl);
//           e.target.value = ""; // reset file input
//           return;
//         }

//         // ✅ Valid image — proceed
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           setImageSrc(reader.result);
//           setIsLocalImage(true);
//           onFileSelect(file);
//         };
//         reader.readAsDataURL(file);

//         URL.revokeObjectURL(objectUrl);
//       };

//       img.onerror = () => {
//         CustomToast.error("Invalid image file");
//         URL.revokeObjectURL(objectUrl);
//       };
//     }
//   };

//   // const handleFileChange = (e) => {
//   //     const file = e.target.files[0];
//   //     if (file) {
//   //         if (!file.type.startsWith('image/')) {
//   //             CustomToast.error('Please select an image file');
//   //             return;
//   //         }

//   //         const objectUrl = URL.createObjectURL(file);

//   //         URL.revokeObjectURL(objectUrl);

//   //         onFileSelect(file);
//   //         const reader = new FileReader();
//   //         reader.onloadend = () => {
//   //             setImageSrc(reader.result);
//   //             setIsLocalImage(true);
//   //         };
//   //         reader.readAsDataURL(file);

//   //     }
//   // };

//   const handleDelete = () => {
//     setImageSrc(null);
//     setIsLocalImage(false);
//     onFileSelect(null);
//   };

//   const handleEdit = () => {
//     const input = document.createElement("input");
//     input.type = "file";
//     input.accept = "image/*";
//     input.onchange = (e) => handleFileChange(e);
//     input.click();
//   };

//   return (
//     <>
//       <Form.Group controlId="formFile">
//         {imageSrc ? (
//           <div className="text-center  image-preview d-flex justify-content-center align-items-center position-relative">
//             <div className="rounded-3 overflow-hidden h-100 w-100">
//               <img
//                 src={
//                   isLocalImage
//                     ? imageSrc
//                     : `${process.env.REACT_APP_BACKEND_URL}/${imageSrc}`
//                 }
//                 alt="Uploaded"
//                 className="w-100 h-100 object-fit-cover"
//               />
//             </div>
//             <div className="d-flex align-items-center gap-3 position-absolute top-0 end-0 m-3">
//               <img
//                 src="/images/png/img-delete.png"
//                 className="pointer"
//                 width={40}
//                 height={40}
//                 onClick={handleDelete}
//                 alt="Delete Icon"
//               />
//               <img
//                 src="/images/png/img-edit.png"
//                 className="pointer"
//                 width={40}
//                 height={40}
//                 onClick={handleEdit}
//                 alt="Edit Icon"
//               />
//             </div>
//           </div>
//         ) : (
//           <Form.Label className="images-upload d-flex justify-content-center align-items-center">
//             <div>
//               <img
//                 className="d-flex justify-content-center m-auto"
//                 src="/images/png/upload.png"
//                 width={40}
//                 height={40}
//                 alt="Upload Icon"
//               />
//               <span>Select your file</span>
//             </div>
//             <Form.Control
//               className="d-none"
//               type="file"
//               accept="image/png, image/jpeg, image/jpg"
//               onChange={handleFileChange}
//               name={name}
//             />
//           </Form.Label>
//         )}
//       </Form.Group>
//     </>
//   );
// }

// export default BlogImageUpload;
